import { TGameVersion, TReflectionQuestions } from '@avid/common';

import { clientFirebase } from '../../firebase';

import { connectVersion } from './versions.connect';

export class ReflectionQuestionsAPI {
  private static connectReflectionQuestions(version: TGameVersion) {
    return connectVersion(version)
      .collection('constants')
      .doc('reflection-questions');
  }

  public static async fetchReflectionQuestions(version: TGameVersion) {
    const data = (await this.connectReflectionQuestions(version).get()).data();

    if (data) {
      return data as TReflectionQuestions;
    }

    return clientFirebase.firestore.constants.getReflectionQuestions();
  }
}
